import React, { useEffect } from "react";
import "./Select.scss";
import api from "../../veracityapi";
import { SelectHead } from "../../SharedComponents/LoginProcess/LoginHead/LoginHead";
import LoginFoot from "../../SharedComponents/LoginProcess/LoginFoot/LoginFoot";
import { Navigate } from "react-router-dom";
import Loading from "../../SharedComponents/LoadingScreen/Loading";
import { websiteList, detectModes } from "../../Redux/actions";
import { useDispatch } from "react-redux";
import { store } from "Redux/store";

const CustomerSelect = () => {

	const dispatch = useDispatch();
	const [customers, setCustomers] = React.useState(null);
	const [selectedCustomer, setSelectedCustomer] = React.useState(null);
	const [websiteGuid, setWebsiteGuid] = React.useState("");
	const [websites, setWebsite] = React.useState(null);
	const adminToolBox = localStorage.getItem("admin");
	const partnerToolBox = localStorage.getItem("isPartner");
	const [inputValue, setInputValue] = React.useState("");
	const [websiteInformation, setWebsiteInformation] = React.useState(null);
	const [filteredValues, setFilteredValues] = React.useState([]);
	const [partnerID, setPartnerID] = React.useState(null);
	const [partnerAdminLoading, setPartnerAdminLoading] = React.useState(false);
	const adminTypeTimeout = React.useRef(false);
	const partnerTypeTimeout = React.useRef(false);

	const restart = () => {
		localStorage.setItem("companyName", null);
		api.setCustomerGUID(null);
		api.setWebsiteGUID(null);
		localStorage.setItem("pending_package", null);
		localStorage.setItem("primaryUser", null);
		localStorage.setItem("isAFPEnabled", null);
		localStorage.setItem("currency_symbol", null);
		localStorage.setItem("Mypartner_id", null);
		localStorage.setItem('selected_site', null);
		localStorage.setItem("selected_customer", null);
		localStorage.setItem(`partner_guid`, null);
		localStorage.removeItem("website_id");
		localStorage.removeItem("timezone");
		localStorage.removeItem("websiteName");
		localStorage.removeItem("websitesNumber");
		localStorage.removeItem("bcn-website-id");


		setSelectedCustomer(null);
		setWebsiteGuid("");
		setWebsite(null);
		setInputValue("");
		setWebsiteInformation(null);
		setFilteredValues([]);
		setPartnerID(null);
	};

	React.useMemo(() => {
		restart();
	}, []);

	if (!api.isUserLoggedIn()) {
		api.logout("Fatal Error")
	};

	const showAdminToolBox = {
		display: adminToolBox === "true" ? "block" : "none"
	};

	const showPartnerToolBox = {
		display: partnerToolBox === "true" ? "block" : "none"
	};

	React.useLayoutEffect(() => {
		document.body.style.backgroundColor = "#662D91"
	});

	const adminToolBoxInputValue = (e) => {
		if (e.key === "Enter") {
			handleSubmit();
		};
		if (adminTypeTimeout.current) {
			clearTimeout(adminTypeTimeout.current);
		}
		adminTypeTimeout.current = setTimeout(() => {
			let websiteId = parseInt(e.target.value);
			if (isNaN(websiteId) && e.target.value !== "") {
				api.GET(`/admin/general/search/${e.target.value}`)
					.then((res) => {
						setFilteredValues(res?.item?.websites);
					})
			} else {
				setFilteredValues([]);
				setInputValue(e.target.value);
			};
		}, 350);
	};


	const handleSubmit = (val) => {
		const websiteID = inputValue !== "" ? inputValue : val
		if (inputValue === "" && val === undefined) {
			alert("Please enter the website Name or ID")
		} else {
			setPartnerAdminLoading(true);
			api.GET(`/admin/website/${websiteID}`, {}, true)
				.then(res => {
					localStorage.setItem(`partner_guid`, res.item.partner_guid);
					localStorage.setItem(`isPartner`, !!res.item.partner_guid);
					localStorage.setItem("currency_symbol", res.item.currency_symbol);
					localStorage.setItem("website_id", res.item.website_id);
					setWebsiteInformation(res.item)
					dispatch(detectModes({
						wtp_status: res.item.status,
						afp_status: res.item.afp_status,
					}));
				}).catch(err => {
					alert("Wrong Website")
					api.setWebsiteGUID(null);
					setPartnerAdminLoading(false);

				});
		};
	};

	const partnerToolBoxInputValue = (e) => {
		if (e.key === "Enter") {
			patnerHandleSubmit()
		};
		if (partnerTypeTimeout.current) {
			clearTimeout(partnerTypeTimeout.current);
		}
		partnerTypeTimeout.current = setTimeout(() => {
			let websiteName = e.target.value;
			if (e.target.value !== "") {
				api.GET(`/partner/subpartners/search/${websiteName}`)
					.then((res) => {
						setFilteredValues(res?.items);
					})
			} else {
				setFilteredValues([]);
				setInputValue(e.target.value);
			};
		}, 350);
	};

	const patnerHandleSubmit = (val) => {
		if (inputValue === "" && val === undefined) {
			alert("Website name not found")
		}
		else {
			setPartnerAdminLoading(true);
			api.GET("/customer/" + val.customer_guid).then(resp => {
				localStorage.setItem("timezone", val.timezone);
				localStorage.setItem("websiteName", val.website_name);
				dispatch(detectModes({
					wtp_status: val.status,
					afp_status: val.afp_status,
				}));
				api.setWebsiteGUID(val.guid);
				setWebsiteGuid(val.guid);

				localStorage.setItem("companyName", resp.item.company);
				api.setCustomerGUID(resp.item.guid);
				localStorage.setItem("pending_package", resp.item.pending_package_guid);
				localStorage.setItem("primaryUser", true);
				localStorage.setItem("isAFPEnabled", resp.item.afp_enabled);
				localStorage.setItem("currency_symbol", resp.item.currency_symbol);
				localStorage.setItem("Mypartner_id", resp.item.Mypartner_id)
				localStorage.setItem('selected_site', val.guid);
				localStorage.setItem("selected_customer", resp.item.guid);
				localStorage.setItem(`partner_guid`, resp.item.partner_guid);
				setPartnerID(resp.item.Mypartner_id);
				setSelectedCustomer(resp.item.guid);
				setWebsiteInformation(val)
			});
		};
	};

	React.useEffect(() => {
		if (websiteInformation !== null) {
			api.setCustomerGUID(websiteInformation.customer_guid)
			api.setWebsiteGUID(websiteInformation.guid)
			localStorage.setItem("websiteName", websiteInformation.website_name)
			localStorage.setItem("timezone", websiteInformation?.timezone ?? "Europe/London");
			dispatch(detectModes({
				wtp_status: websiteInformation?.status,
				afp_status: websiteInformation?.afp_status,
			}));
		}
	}, [websiteInformation]);

	const onCustomerClick = (event, customer) => {
		localStorage.setItem("companyName", event.target.innerText)
		api.setCustomerGUID(customer.guid);
		localStorage.setItem("pending_package", customer.pending_package_guid)
		localStorage.setItem("primaryUser", customer.primary_user);
		localStorage.setItem("isAFPEnabled", customer.afp_enabled);
		localStorage.setItem("currency_symbol", customer.currency_symbol);
		localStorage.setItem("Mypartner_id", customer.Mypartner_id)
		setPartnerID(customer.Mypartner_id)
		setSelectedCustomer(customer.guid);
	};

	const onWebsiteClick = (event, key) => {
		for (let i = 0; i < websites.length; i++) {
			if (websites[i].guid === key) {
				localStorage.setItem("timezone", websites[i]?.timezone);
				localStorage.setItem("websiteName", websites[i].website_name);
				dispatch(detectModes({
					wtp_status: websites[i]?.status,
					afp_status: websites[i]?.afp_status,
				}));
			};
		};
		api.setWebsiteGUID(key);
		setWebsiteGuid(key);
	};



	if (customers === null) {
		api.GET("/customer").then(resp => {
			localStorage.setItem('customersNumber', resp?.items?.length)
			setCustomers(resp.items)
			if (resp.items.length === 1 && adminToolBox !== "true") {
				api.setCustomerGUID(resp.items[0].guid);
				localStorage.setItem("pending_package", resp.items[0].pending_package_guid)
				localStorage.setItem("companyName", resp.items[0].company);
				localStorage.setItem("primaryUser", resp.items[0].primary_user)
				localStorage.setItem("isAFPEnabled", resp.items[0].afp_enabled)
				localStorage.setItem("currency_symbol", resp.items[0].currency_symbol)
				localStorage.setItem("Mypartner_id", resp.items[0].Mypartner_id)
				setSelectedCustomer(resp.items[0].guid);
				setPartnerID(resp.items[0].Mypartner_id)
			};
		}).catch((error) => {
			// api.logout("permissions Error.")
		})
	};

	if (websites === null && api.getCustomerGUID() !== null) {

		api.GET(`/website/customer/${api.getCustomerGUID()}`).then(resp => {
			dispatch(websiteList(resp));
			setWebsite(resp.items);
			localStorage.setItem("websitesNumber", resp.items.length)
			if (resp.items.length === 1 && !partnerID && partnerToolBox !== "true" && adminToolBox !== "true") {
				api.setWebsiteGUID(resp.items[0].guid);
				localStorage.setItem("timezone", resp.items[0]?.timezone);
				localStorage.setItem("websiteName", resp.items[0].website_name);
				dispatch(detectModes({
					wtp_status: resp.items[0]?.status,
					afp_status: resp.items[0]?.afp_status,
				}));
			};
		}).catch((error) => {
			console.log(error);
			// api.logout("permissions Error.")
		})
	};

	if (websites === null && customers === null) {
		return (
			<>
				<SelectHead />
				<Loading />
				<LoginFoot />
			</>
		)
	};

	const websiteGUID = api.getWebsiteGUID() ?? false
	if (websiteGUID) {
		return (
			<Navigate to="/loading" />
		);
	};

	if (!api.isUserLoggedIn()) {
		return (
			<Navigate to="/login" />
		);
	};

	if (partnerAdminLoading) {
		return (
			<>
				<SelectHead />
				<Loading />
				<LoginFoot />
			</>
		)
	};

	if (showPartnerToolBox.display === "block" && showAdminToolBox.display === "none") {
		return (
			<div className="select-page">
				<SelectHead />
				<div className="admin--tools" style={showPartnerToolBox}>
					<p className="admin--tools_title">Website Search</p>
					<div className="admin--tools_form">
						<h2 className="admin--tools_heading">Please type below to search</h2>
						<span><input type="text" placeholder="Enter name or URL" id="adminBox" onKeyUp={partnerToolBoxInputValue} className="admin--tools_input" required></input></span>
						<span><button type="submit" className="admin--tools_button" onClick={() => patnerHandleSubmit(filteredValues[0])}>Submit</button></span>
					</div>
					{filteredValues.length > 0 &&
						<div className="filteredValues-section">
							{filteredValues?.map((val) =>
								<li key={val.guid} className="filtered_items" onClick={() => patnerHandleSubmit(val)}>{val?.website_name}</li>
							)
							}
						</div>
					}
				</div>
				<LoginFoot />
			</div>
		);
	}

	if ((customers !== null && api.getCustomerGUID() === null)) {
		return (
			<div className="select-page">
				<SelectHead />
				<div className="select-form">
					<p className="select-text">Select Customer</p>
					{
						customers.map(customer => (
							<div className="customer-select"
								key={
									customer.guid
								}
								onClick={
									(event) => {
										onCustomerClick(event, customer)
									}
								}>
								<span className="customer-heading">
									{
										customer.company
									}</span>
							</div>
						))
					}

				</div>
				<LoginFoot />
			</div>
		);
	};

	if (websites !== null) {

		return (
			<div className="select-page">
				<SelectHead />
				<div className="select-form">
					<div className="header-container">
						<h1 className="select-text select-text--bkcustomers" onClick={restart}>← Customers</h1>
						<h1 className="select-text">Select Website</h1>
					</div>
					{
						websites.map(website => (
							<div className="website-select"
								key={website.guid} onClick={(event) => { onWebsiteClick(event, website.guid) }}>
								<div className="website-details">
									<span className="website-names">{website.website_name === null ? website.primary_hostname : website.website_name.replace("www.", "")}</span>
								</div>
							</div>
						))
					}
				</div>
				<div className="admin--tools" style={showAdminToolBox}>
					<p className="admin--tools_title">Admin tools</p>
					<div className="admin--tools_form">
						<h2 className="admin--tools_heading">Search Website</h2>
						<span><input type="text" placeholder="Enter website name or ID" id="adminBox" onKeyUp={adminToolBoxInputValue} className="admin--tools_input" required></input></span>
						<span><button type="submit" className="admin--tools_button" onClick={() => handleSubmit()}>Submit</button></span>
					</div>
					{filteredValues.length > 0 &&
						<div className="filteredValues-section">
							{filteredValues?.map((val) =>
								<li key={val.guid} className="filtered_items" onClick={() => handleSubmit(val?.website_id)}>{val?.website_name}</li>
							)
							}
						</div>
					}
				</div>
				<LoginFoot />
			</div>
		);

	} else {

		return (
			<>
				<SelectHead />
				<Loading />
				<LoginFoot />
			</>

		)
	}
};

export default CustomerSelect;
